import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../Login/Login';
import './Dashboard.css';

async function changePassword(credentials) {

  return fetch('https://ekselowe.pl/api/changepassword.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json())
}



export default function Dashboard({ setIsLoggedin, isLoggedin, loginHandler }) {
  const navigate = useNavigate();

  const changeToken = async () => {
    try {
      await fetch('https://ekselowe.pl/api/resettoken.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: isLoggedin }),
      });
      loginHandler();
    } catch (err) {

    }
  }



  const [passwordold, setPasswordOld] = useState("");
  const [password, setPassword] = useState("");
  const [passwordre, setPasswordRe] = useState("");
  const handleSubmit = async e => {
    e.preventDefault();

    if (password !== passwordre) {
      alert("Podane hasła nie zgadzają się");
      return;
    }

    if (password === "" || passwordold === "") {
      alert("Nie podano hasła");
      return;
    }

    const token = await changePassword({
      passwordold,
      password,
    });
    console.log(Object.keys(token));
    if (Object.keys(token)[0] === "error") {
      alert("Złe hasło");
    }
    if (Object.keys(token)[0] === "success") {
      alert("Hasło zostało zmienione, wylogowywanie");

      loginHandler();

    }

  }



  if (!isLoggedin) {
    return <Login setToken={setIsLoggedin} />
  }
  return (
    <div className='dashboard-wrapper'>
      <h1>Dashboard</h1>
      <h2>zalogowano</h2>
      <button className="nav-item-left" onClick={loginHandler}>Wyloguj</button>
      <h1></h1>
      <h2>Aktualności</h2>
      <button className="nav-item-left" onClick={() => navigate('/dashboard/aktualnosci')}>Zarządzaj Aktualnościami</button>
      <h1></h1>
      <h2>Zmiana hasła</h2>

      <form onSubmit={handleSubmit}>
        <label>
          <p>Stare hasło</p>
          <input type="password" onChange={e => setPasswordOld(e.target.value)} />
        </label>
        <label>
          <p>Nowe hasło</p>
          <input type="password" onChange={e => setPassword(e.target.value)} />
        </label>
        <label>
          <p>Powtórz hasło</p>
          <input type="password" onChange={e => setPasswordRe(e.target.value)} />
        </label>
        <div>
          <button className="nav-item-left" type="submit">Zmień hasło</button>
        </div>
      </form>
      <h1></h1>
      <h2>Wyloguj wszędzie</h2>
      <button className="nav-item-left" onClick={changeToken} >Wyloguj z wszystkich urządzeń / zmień token</button>
      <h1></h1>
    </div>
  );
}
